module.exports = __webpack_public_path__ + "static/images/add-friend.0ddd81cb0e87cbeaf3875c0deade8cc5.svg";